<template>
  <div id="baseFormATCommand" class="cmd-root">
    <div class="cmd-panel">
      <div class="cmd-thread-wrap">
      <ul ref="chatList" class="cmd-thread" @scroll="onChatScroll">
        <li v-if="items.length <= 0" class="cmd-empty">
          <span class="cmd-empty-icon"><i class="fa fa-comments-o"></i></span>
          <strong>Chưa có lệnh nào</strong>
          <span>Chọn loại lệnh ở bên phải, rồi gửi tới thiết bị.</span>
        </li>
        <template v-for="(each, index) in items">
          <li v-if="each.cmd" class="cmd-msg cmd-msg-out" :key="'cmd-' + index">
            <span class="cmd-msg-meta">
              Đã gửi
              <time v-if="each.createDate">{{ $helper.formatDate(each.createDate) }}</time>
            </span>
            <span class="cmd-msg-body">
              <button type="button" class="cmd-copy" v-c-tooltip.hover="'Sao chép'"
                @click.stop="copyText(each.cmd)">
                <i class="fa fa-copy"></i>
              </button>
              {{ each.cmd }}
            </span>
          </li>
          <li v-if="each.data" class="cmd-msg cmd-msg-in" :key="'data-' + index">
            <span class="cmd-msg-meta">
              Phản hồi
              <time v-if="each.updateDate">{{ $helper.formatDate(each.updateDate) }}</time>
            </span>
            <span class="cmd-msg-body">
              <button type="button" class="cmd-copy" v-c-tooltip.hover="'Sao chép'"
                @click.stop="copyText(each.data)">
                <i class="fa fa-copy"></i>
              </button>
              {{ each.data }}
            </span>
          </li>
        </template>
      </ul>
      <transition name="cmd-jump">
        <button v-if="canScrollUp" type="button" class="cmd-jump cmd-jump-up" aria-label="Lên đầu"
          @click="scrollChatTo('top')">
          <i class="fa fa-angle-up"></i>
          Lên đầu
        </button>
      </transition>
      <transition name="cmd-jump">
        <button v-if="canScrollDown" type="button" class="cmd-jump cmd-jump-down" aria-label="Xuống cuối"
          @click="scrollChatTo('bottom')">
          <i class="fa fa-angle-down"></i>
          Xuống cuối
        </button>
      </transition>
      </div>

      <aside class="cmd-composer">
        <div class="cmd-switch" role="tablist">
          <button type="button" :class="{ 'is-active': commandOption === 'custom' }"
            @click="setCommandOption('custom')">Tùy chỉnh</button>
          <button type="button" :class="{ 'is-active': commandOption === 'mac' }"
            @click="setCommandOption('mac')">MAC</button>
          <button type="button" :class="{ 'is-active': commandOption === 'log' }"
            @click="setCommandOption('log')">Log</button>
        </div>

        <template v-if="commandOption === 'mac'">
          <label class="cmd-label" for="cmdMacInput">MAC mới</label>
          <input id="cmdMacInput" type="text" class="cmd-input cmd-input-mono" v-model="macInput" placeholder="Nhập MAC"
            @keyup.enter="submitSendATCmd()" @blur="normalizeMacInput" />
          <p class="cmd-help" :class="{ 'is-ok': !!formattedMac }">
            {{ formattedMac ? 'Cấu hình sẽ gửi hwinfotool -m0=' + formattedMac : 'Nhập MAC có hoặc không có dấu :. Lấy MAC hiện tại không cần nhập.' }}
          </p>
          <button type="button" class="cmd-fetch" :disabled="!timeoutValid" @click.prevent="submitGetMac()">
            Lấy MAC hiện tại
          </button>
        </template>
        <template v-else-if="commandOption === 'log'">
          <label class="cmd-label" for="cmdLogLines">Số dòng</label>
          <input id="cmdLogLines" type="number" min="1" max="100" class="cmd-input" v-model.number="logLines"
            @blur="normalizeLogLines" @keyup.enter="submitSendATCmd()" />
          <p class="cmd-help">Mặc định 50 dòng, tối đa 100 dòng.</p>
          <label class="cmd-label" for="cmdLogPath">Đường dẫn file</label>
          <input id="cmdLogPath" type="text" class="cmd-input cmd-input-mono" v-model="logPath"
            placeholder="/opt/speaker/app.log" @keyup.enter="submitSendATCmd()" />
          <p class="cmd-help is-ok">Sẽ gửi {{ logCommand }}</p>
          <button type="button" class="cmd-fetch" :disabled="!timeoutValid" @click.prevent="submitListSpeaker()">
            Kiểm tra speaker
          </button>
        </template>
        <template v-else>
          <label class="cmd-label" for="cmdCustomInput">Lệnh gửi đi</label>
          <textarea id="cmdCustomInput" ref="inputCmd" class="cmd-textarea" v-model="contentCmd" rows="8"
            placeholder="Nhập command" @keydown.ctrl.enter.prevent="submitSendATCmd()"
            @keydown.meta.enter.prevent="submitSendATCmd()"></textarea>
          <p class="cmd-help">Ctrl+Enter để gửi. Xuống dòng bằng Enter.</p>
        </template>

        <div class="cmd-sendline">
          <label class="cmd-timeout">
            <span>Timeout (giây)</span>
            <input type="number" min="1" v-model.number="timeoutCmd" @keyup.enter="submitSendATCmd()" />
          </label>
          <button type="button" class="cmd-submit" :disabled="!canSend" @click.prevent="submitSendATCmd()">
            <i class="fa fa-paper-plane"></i>
            Gửi
          </button>
        </div>
      </aside>
    </div>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseFormLoading from "../base/BaseFormLoading";

export default {
  name: "BaseFormATCommand",
  components: {
    BaseFormLoading
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  props: {
    phoneNumber: {
      type: String,
      default: ""
    },
    deviceId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: { value: false },
      commandOption: "custom",
      contentCmd: "",
      macInput: "",
      logLines: 50,
      logPath: "",
      timeoutCmd: 30,
      pageSize: 10,
      pageNumber: 0,
      totalElement: 0,
      totalPages: 0,
      items: [],
      canScrollUp: false,
      canScrollDown: false
    }
  },
  computed: {
    formattedMac() {
      return this.formatMac(this.macInput);
    },
    normalizedLogLines() {
      const lines = parseInt(this.logLines, 10);
      if (!Number.isFinite(lines) || lines < 1) {
        return 50;
      }
      return Math.min(lines, 100);
    },
    logCommand() {
      const path = (this.logPath || "").trim() || "/opt/speaker/app.log";
      return "tail -n " + this.normalizedLogLines + " " + path;
    },
    commandPreview() {
      return this.buildCommand(false);
    },
    timeoutValid() {
      return Number(this.timeoutCmd) >= 1;
    },
    canSend() {
      return !!this.commandPreview && this.timeoutValid;
    }
  },
  methods: {
    copyText(text) {
      const value = text == null ? "" : String(text);
      const done = () => this.showSuccessMsg({ message: "Đã sao chép" });
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(done).catch(() => this.copyTextFallback(value, done));
        return;
      }
      this.copyTextFallback(value, done);
    },
    copyTextFallback(value, done) {
      const area = document.createElement("textarea");
      area.value = value;
      area.setAttribute("readonly", "");
      area.style.position = "fixed";
      area.style.left = "-9999px";
      document.body.appendChild(area);
      area.select();
      document.execCommand("copy");
      document.body.removeChild(area);
      done();
    },
    setCommandOption(option) {
      this.commandOption = option;
      this.$nextTick(() => {
        if (option === "custom" && this.$refs.inputCmd) {
          this.$refs.inputCmd.focus();
        }
      });
    },
    formatMac(raw) {
      if (raw === null || raw === undefined) {
        return "";
      }
      const hex = String(raw).toUpperCase().replace(/[^0-9A-F]/g, "");
      if (hex.length !== 12) {
        return "";
      }
      return hex.match(/.{1,2}/g).join(":");
    },
    normalizeMacInput() {
      const formatted = this.formatMac(this.macInput);
      if (formatted) {
        this.macInput = formatted;
      }
    },
    normalizeLogLines() {
      this.logLines = this.normalizedLogLines;
    },
    buildCommand(showError) {
      if (this.commandOption === "mac") {
        const mac = this.formatMac(this.macInput);
        if (!mac) {
          if (showError) {
            this.showErrorMsg({ message: "MAC không hợp lệ. Cần đúng 12 ký tự hex, ví dụ 66:D7:1F:00:01:C7" });
          }
          return "";
        }
        return "hwinfotool -m0=" + mac;
      }
      if (this.commandOption === "log") {
        return this.logCommand;
      }
      return (this.contentCmd || "").trim();
    },
    onChatScroll() {
      const chatWindow = this.$refs.chatList;
      if (!chatWindow) {
        return;
      }
      this.updateChatScrollState();
      if (!this.loading.value && chatWindow.scrollTop <= 200 && this.pageNumber < this.totalPages) {
        this.loading.value = true;
        this.loadMessageATCmd();
      }
    },
    updateChatScrollState() {
      const chatWindow = this.$refs.chatList;
      if (!chatWindow) {
        this.canScrollUp = false;
        this.canScrollDown = false;
        return;
      }
      const maxScroll = chatWindow.scrollHeight - chatWindow.clientHeight;
      this.canScrollUp = chatWindow.scrollTop > 4;
      this.canScrollDown = maxScroll - chatWindow.scrollTop > 4;
    },
    scrollChatTo(edge) {
      const chatWindow = this.$refs.chatList;
      if (!chatWindow) {
        return;
      }
      const top = edge === "top" ? 0 : chatWindow.scrollHeight;
      if (typeof chatWindow.scrollTo === "function") {
        chatWindow.scrollTo({ top: top, behavior: "smooth" });
      } else {
        chatWindow.scrollTop = top;
      }
    },
    submitGetMac() {
      this.sendCommand("hwinfotool -f", false);
    },
    submitListSpeaker() {
      this.sendCommand("ls -l /opt/speaker", false);
    },
    submitSendATCmd() {
      if (this.commandOption === "mac") {
        this.normalizeMacInput();
      }
      if (this.commandOption === "log") {
        this.normalizeLogLines();
      }
      const command = this.buildCommand(true);
      if (!command) {
        if (this.commandOption === "custom") {
          this.showErrorMsg({ message: "Command không để trống" });
        }
        return;
      }
      this.sendCommand(command, this.commandOption === "mac");
    },
    sendCommand(command, clearMac) {
      const timeout = Number(this.timeoutCmd);
      if (!timeout || timeout < 1) {
        this.showErrorMsg({ message: "Timeout phải lớn hơn 0" });
        return;
      }
      let that = this;
      this.$helper.loadDataSource({
        url: "/at-cmd/sendATCmd",
        dataSubmit() {
          return {
            phoneNumber: that.phoneNumber || "",
            cmd: encodeURIComponent(command),
            deviceId: that.deviceId,
            timeout: timeout
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            if (clearMac) {
              that.macInput = "";
            } else if (that.commandOption === "custom") {
              that.contentCmd = "";
            }
            that.items.push({ cmd: response.data.data.cmd, createDate: response.data.data.createDate });
            that.scrollToBottomChat();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    loadMessageATCmd() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/at-cmd/getPages",
        dataSubmit() {
          return {
            pageSize: that.pageSize,
            pageNumber: that.pageNumber,
            phoneNumber: that.phoneNumber || "",
            deviceId: that.deviceId
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.totalElement = response.data.data.totalElement;
            const content = response.data.data.dataContent && response.data.data.dataContent.content
              ? response.data.data.dataContent.content
              : [];
            const chatWindow = that.$refs.chatList;
            const isFirstPage = that.pageNumber === 0;
            const prevHeight = chatWindow ? chatWindow.scrollHeight : 0;
            const prevTop = chatWindow ? chatWindow.scrollTop : 0;
            content.map(each => that.items.unshift(each));
            that.pageNumber += 1;
            that.totalPages = Math.ceil(that.totalElement / that.pageSize);
            that.loading.value = false;
            that.$nextTick(() => {
              if (!chatWindow) {
                return;
              }
              if (isFirstPage) {
                chatWindow.scrollTop = chatWindow.scrollHeight - chatWindow.clientHeight;
              } else {
                chatWindow.scrollTop = prevTop + (chatWindow.scrollHeight - prevHeight);
              }
              that.updateChatScrollState();
            });
          }
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    scrollToBottomChat() {
      this.$nextTick(() => {
        const chatWindow = this.$refs.chatList;
        if (!chatWindow) return;
        chatWindow.scrollTop = chatWindow.scrollHeight - chatWindow.clientHeight;
        this.updateChatScrollState();
      });
    }
  },
  mounted() {
    if (this.$refs.inputCmd) {
      this.$refs.inputCmd.focus();
    }
    this.loadMessageATCmd();
    this.scrollToBottomChat();
  },
  watch: {
    "$store.state.atCmd": function (value) {
      if (!value || !value.data || value.data.data === undefined || value.data.data === null) {
        return;
      }
      this.items.push({ data: value.data.data, updateDate: value.data.updateDate });
      this.scrollToBottomChat();
    }
  }
};
</script>
<style scoped>
.cmd-root {
  position: relative;
}

.cmd-panel {
  display: flex;
  flex-direction: row;
  height: min(760px, calc(100vh - 120px));
  min-height: 540px;
  border: 1px solid #e6ebf2;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

.cmd-thread-wrap {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 160px;
}

.cmd-thread {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 160px;
  margin: 0;
  padding: 16px;
  overflow-y: auto;
  list-style: none;
  background:
    radial-gradient(circle at top left, rgba(37, 99, 235, 0.07), transparent 40%),
    #f6f8fb;
}

.cmd-jump {
  position: absolute;
  left: 50%;
  z-index: 2;
  height: 34px;
  padding: 0 14px;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  color: #0f172a;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transform: translateX(-50%);
  backdrop-filter: blur(8px);
}

.cmd-jump-up {
  top: 12px;
}

.cmd-jump-down {
  bottom: 12px;
}

.cmd-jump .fa {
  font-size: 16px;
  margin: 0;
}

.cmd-jump:hover {
  background: #2563eb;
  color: #fff;
}

.cmd-jump-enter-active,
.cmd-jump-leave-active {
  transition: opacity 0.18s ease;
}

.cmd-jump-enter,
.cmd-jump-leave-to {
  opacity: 0;
}

.cmd-empty {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
  color: #64748b;
}

.cmd-empty-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e8eef8;
  color: #2563eb;
  font-size: 20px;
  margin-bottom: 6px;
}

.cmd-empty strong {
  color: #0f172a;
  font-size: 15px;
}

.cmd-msg {
  max-width: min(86%, 520px);
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cmd-msg-out {
  align-self: flex-end;
  align-items: flex-end;
}

.cmd-msg-in {
  align-self: flex-start;
  align-items: flex-start;
}

.cmd-msg-meta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #64748b;
}

.cmd-msg-meta time {
  font-weight: 500;
  color: #94a3b8;
}

.cmd-msg-body {
  position: relative;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 13px;
  line-height: 1.45;
  padding: 10px 32px 10px 12px;
}

.cmd-copy {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  line-height: 1;
}

.cmd-copy .fa {
  font-size: 12px;
  margin: 0;
}

.cmd-msg-out .cmd-copy {
  color: rgba(255, 255, 255, 0.92);
}

.cmd-msg-out .cmd-copy:hover {
  background: rgba(255, 255, 255, 0.18);
}

.cmd-msg-in .cmd-copy {
  color: #64748b;
}

.cmd-msg-in .cmd-copy:hover {
  background: #e2e8f0;
  color: #1d4ed8;
}

.cmd-msg-out .cmd-msg-body {
  color: #fff;
  background: linear-gradient(135deg, #0b98ff 0%, #2563eb 100%);
  border-radius: 14px 14px 4px 14px;
}

.cmd-msg-in .cmd-msg-body {
  color: #0f172a;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px 14px 14px 4px;
}

.cmd-composer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 380px;
  flex: 0 0 380px;
  padding: 16px;
  border-left: 1px solid #e6ebf2;
  background: #fff;
  box-sizing: border-box;
}

.cmd-switch {
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background: #f1f5f9;
}

.cmd-switch button {
  flex: 1 1 0;
  height: 36px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.cmd-switch button.is-active {
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

.cmd-label,
.cmd-timeout span {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
}

.cmd-input,
.cmd-textarea,
.cmd-timeout input {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #d7dee8;
  background: #fff;
  color: #0f172a;
  outline: none;
  box-sizing: border-box;
}

.cmd-input,
.cmd-timeout input {
  height: 42px;
  padding: 0 12px;
}

.cmd-textarea {
  min-height: 180px;
  padding: 10px 12px;
  resize: vertical;
  line-height: 1.45;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.cmd-input:focus,
.cmd-textarea:focus,
.cmd-timeout input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.cmd-input-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  letter-spacing: 0.02em;
}

.cmd-help {
  margin: 6px 0 0;
  font-size: 12px;
  color: #64748b;
}

.cmd-help.is-ok {
  color: #15803d;
}

.cmd-fetch {
  width: 100%;
  height: 42px;
  margin-top: 4px;
  border-radius: 10px;
  border: 1px solid #bfdbfe;
  background: #fff;
  color: #1d4ed8;
  font-weight: 700;
  cursor: pointer;
}

.cmd-fetch:hover:not(:disabled) {
  background: #eff6ff;
}

.cmd-fetch:disabled {
  color: #94a3b8;
  border-color: #e2e8f0;
  cursor: not-allowed;
}

.cmd-sendline {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-top: auto;
}

.cmd-timeout {
  margin: 0;
  width: 112px;
  flex: 0 0 112px;
}

.cmd-timeout input {
  text-align: center;
}

.cmd-submit {
  height: 42px;
  flex: 1 1 auto;
  padding: 0 16px;
  border: 0;
  border-radius: 10px;
  background: #2563eb;
  color: #fff;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}

.cmd-submit:hover:not(:disabled) {
  background: #1d4ed8;
}

.cmd-submit:disabled {
  background: #94a3b8;
  box-shadow: none;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .cmd-panel {
    flex-direction: column;
    height: min(820px, calc(100vh - 100px));
  }

  .cmd-thread {
    min-height: 240px;
  }

  .cmd-composer {
    width: 100%;
    flex-basis: auto;
    border-left: 0;
    border-top: 1px solid #e6ebf2;
  }

  .cmd-sendline {
    margin-top: 0;
  }
}
</style>
